"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
// import app components
const colors_1 = __importDefault(require("../colors"));
const table = {
    MuiTable: {
        styleOverrides: {
            root: {
                width: "100%",
            },
        },
    },
    MuiTableHead: {
        styleOverrides: {
            root: {
                whiteSpace: "nowrap",
                backgroundColor: colors_1.default.secondary[600],
            },
        },
    },
    MuiTableCell: {
        styleOverrides: {
            root: {
                padding: "10px",
                [constants_1.breakpoints.up("md")]: {
                    padding: "16px",
                },
                borderColor: colors_1.default.border[800],
            },
            sizeSmall: {
                padding: "6px",
                [constants_1.breakpoints.up("md")]: {
                    padding: "8px",
                },
            },
            stickyHeader: {
                backgroundColor: colors_1.default.secondary[700],
            },
        },
    },
    MuiTableRow: {
        styleOverrides: {
            root: {
                "& th": {
                    fontWeight: "bold",
                },
                "&.MuiTableRow-hover:hover": {
                    cursor: "pointer",
                    backgroundColor: colors_1.default.secondaryHover[600],
                },
                "&:last-of-type": {
                    td: {
                        borderBottom: "none",
                    },
                },
            },
        },
    },
    MuiTablePagination: {
        styleOverrides: {
            spacer: {
                display: "none",
            },
            toolbar: {
                padding: 0,
            },
        },
    },
};
exports.default = table;
